import axios from "axios";
import { API_BASE_PATH } from "../../environment";

const DASHBOARD_BASE_URL = `${API_BASE_PATH}/Admindashboard`;

// Types
export interface DashboardStatsResponse {
  total_clients?: number;
  total_projects?: number;
  total_income?: number;
  total_expense?: number;
  active_users?: number;
  [key: string]: any;
}

export interface DepartmentWithEmployeeCount {
  department_id: number;
  department_name: string;
  employee_count: number;
}

export interface EmployeeBirthday {
  employee_id: string;
  employee_name: string;
  date_of_birth: string;
  department_name: string;
  designation: string | null;
}

// Functions
export const fetchAllDashboardStats =
  async (): Promise<DashboardStatsResponse | null> => {
    try {
      const response = await axios.get<DashboardStatsResponse>(
        `${DASHBOARD_BASE_URL}/all-total_dashboard`,
        {
          headers: {
            accept: "application/json",
          },
        }
      );

      const raw = response.data;

      const transformed: DashboardStatsResponse = {
        total_clients: raw.total_clients ?? 0,
        total_projects: raw.total_projects ?? 0,
        total_income: raw.total_income ?? 0,
        total_expense: raw.total_expense ?? 0,
        active_users: raw.active_users ?? 0,
      };

      return transformed;
    } catch (error) {
      console.error("Failed to fetch dashboard stats:", error);
      return null;
    }
  };

export const fetchDepartmentsWithEmployeeCount = async (): Promise<
  DepartmentWithEmployeeCount[] | null
> => {
  try {
    const response = await axios.get<DepartmentWithEmployeeCount[]>(
      `${DASHBOARD_BASE_URL}/departments-with-employee-count`,
      {
        headers: {
          accept: "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Failed to fetch departments with employee count:", error);
    return null;
  }
};

export const fetchEmployeeBirthdays = async (): Promise<
  EmployeeBirthday[] | null
> => {
  try {
    const response = await axios.get<EmployeeBirthday[]>(
      `${DASHBOARD_BASE_URL}/employee/birthday`,
      {
        headers: {
          accept: "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("❌ Failed to fetch employee birthdays:", error);
    return null;
  }
};
